// extracted by mini-css-extract-plugin
export default {"root":"undo_root__ivOnd","content":"undo_content__Ru3f6","bar":"undo_bar__-D8-o"};